import { _ } from './../utils.js'
export default class RadioToggle {
    constructor(el) {
        this.el = el
        this.el.addEventListener('change', this.toggleSection)
        this.checkSelection()
    }

    checkSelection = () => {
        if (this.el.checked) {
            this.toggleSection(false, this.el.dataset.target, this.el)
        }
    }

    toggleSection = (e, triggerTarget, trigger) => {
        if (e) {
            triggerTarget = e.currentTarget.dataset.target
            trigger = e.currentTarget
        }
        const target = _(triggerTarget, 'element').node()
        const targetClass = target.dataset.class

        if (trigger.checked && trigger.dataset.status === 'on') {
            target.classList.remove(targetClass)
        }

        if (trigger.checked && trigger.dataset.status === 'off') {
            target.classList.add(targetClass)
            const priceInputs = _('price-input').nodesFrom(target)
            const changeEvent = new Event('change')
            priceInputs.map((input) => {
                input.value = 0
                input.dispatchEvent(changeEvent)
            })
        }
    }
}
